import axiosInstance from "./axios";

// DB-connectivity probe for the "Currently Under Maintenance" gate (issue #77).
// Goes through the shared axiosInstance so withCredentials + X-App-Name +
// X-Requested-With are all set. Resolves true when the API reports healthy,
// false on a 503 (DBs unreachable) or any network/transport failure.
export async function checkHealth() {
    try {
        const response = await axiosInstance.get("api/health");
        return response.status >= 200 && response.status < 300;
    } catch (error) {
        return false;
    }
}

export default checkHealth;
